module["exports"] = [
  "майдан"
];
